<template>
    <ui-icon v-bind:style="{fontSize:'1.5em'}" class="icon" backgroundColor="#DDDDDD" color="#666666" icon="ellipsis-h"></ui-icon>
</template>

<script>

import UiIcon from '../UiIcon.vue'

export default {
  name: 'icon-button-options',
  props:{
  },
  data:function(){
    return {
    }
  },
  methods:{
  },
  mounted:function(){
    
  },
  components:{
    UiIcon
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.icon{
  cursor:pointer
}
</style>
